import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)
export default new Vuex.Store({
    state:{

    },
    mutations: {
        // 修改状态的方法
    },
    actions: {
        // 异步操作
    }
})
